// src/pages/legal/PrivacyPolicy.js
import React from "react";
import { Container, Typography } from "@mui/material";

const PrivacyPolicy = () => (
  <Container sx={{ mt: 4 }}>
    <Typography variant="h4" gutterBottom>Privacy Policy</Typography>
    <Typography variant="body1" paragraph>

      <strong>Last updated: 2025-09-12</strong><br /><br />

      HPHT Technology ("HPHT", "we", "us", or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard your information through our vending machine interfaces, mobile web applications, and any services offered through these platforms (collectively, the "Services").
      <br /><br />

      By accessing or using any part of the Services, you agree to the collection, use, and disclosure of your information as described in this Privacy Policy. If you do not agree, please do not use our Services.
    </Typography>

    <Typography variant="h6" gutterBottom>1. What Data We Collect</Typography>
    <Typography variant="body1" paragraph>
      We collect personal data when you:
      <ul>
        <li>Use our vending machines or web app</li>
        <li>Register for an account or log in to access private vending machines</li>
        <li>Make a payment via Razorpay</li>
        <li>Contact customer support via WhatsApp or email</li>
      </ul>
      This data may include your name, email, phone number, payment confirmation, machine UID, session ID, and order history.
    </Typography>

    <Typography variant="h6" gutterBottom>2. How We Use Your Data</Typography>
    <Typography variant="body1" paragraph>
      We use the information we collect to:
      <ul>
        <li>Fulfill your purchases and generate QR codes for collection</li>
        <li>Verify authentication for access to private vending machines</li>
        <li>Send transaction updates via web UI or WhatsApp</li>
        <li>Improve the performance and functionality of our machines and web platform</li>
        <li>Respond to customer service requests</li>
      </ul>
    </Typography>

    <Typography variant="h6" gutterBottom>3. How We Protect Your Data</Typography>
    <Typography variant="body1" paragraph>
      We implement reasonable technical and organizational measures to protect your personal data against unauthorized access, loss, misuse, or alteration. Access to sensitive data is restricted to authorized staff only.
    </Typography>

    <Typography variant="h6" gutterBottom>4. Payment Information</Typography>
    <Typography variant="body1" paragraph>
      All payments are processed securely via Razorpay. We do not store your credit card or banking information on our servers. Any data captured during payment (e.g., transaction ID, order ID, session ID) is used strictly for order fulfillment and troubleshooting.
    </Typography>

    <Typography variant="h6" gutterBottom>5. Cookies and Device Data</Typography>
    <Typography variant="body1" paragraph>
      Our website may use cookies to remember your preferences and enhance user experience. We may also collect anonymous device information such as IP address and browser type for analytics and security.
    </Typography>

    <Typography variant="h6" gutterBottom>6. Sharing of Data</Typography>
    <Typography variant="body1" paragraph>
      We do not sell or rent your personal data to third parties. We may share your information with:
      <ul>
        <li>Razorpay for payment processing</li>
        <li>Cloud-based vendors (e.g., hosting providers) to support our web services</li>
        <li>Legal authorities if required by law</li>
      </ul>
    </Typography>

    <Typography variant="h6" gutterBottom>7. Data Retention</Typography>
    <Typography variant="body1" paragraph>
      We retain your data only as long as necessary for transaction records, dispute handling, and legal compliance. You may request data deletion at any time.
    </Typography>

    <Typography variant="h6" gutterBottom>8. Your Rights</Typography>
    <Typography variant="body1" paragraph>
      You have the right to:
      <ul>
        <li>Access your data</li>
        <li>Request corrections</li>
        <li>Withdraw your consent</li>
        <li>Request deletion</li>
      </ul>
      Contact us via WhatsApp or email to exercise your rights.
    </Typography>

    <Typography variant="h6" gutterBottom>9. Children's Privacy</Typography>
    <Typography variant="body1" paragraph>
      Our vending and online services are not intended for children under 13. We do not knowingly collect personal data from minors.
    </Typography>

    <Typography variant="h6" gutterBottom>10. Changes to this Policy</Typography>
    <Typography variant="body1" paragraph>
      We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
    </Typography>

    <Typography variant="h6" gutterBottom>11. Contact Us</Typography>
    <Typography variant="body1" paragraph>
      If you have any questions or concerns regarding this Privacy Policy or your personal data, you may reach us via WhatsApp at <strong>+60164709459</strong> or email <strong>sales@hphttech.com</strong>.
    </Typography>
  </Container>
);

export default PrivacyPolicy;
